import { MainLayout } from 'layouts/MainLayout'
import { NextPageWithLayout } from 'next'
import Script from 'next/script'

const PrivacyPolicy: NextPageWithLayout = () => {
  return (
    <>
      <div
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        name='termly-embed'
        data-id='732504e4-461e-4ffa-a936-8be41ad7db02'
        datatype='iframe'
      />
      <Script id='termsOfUse' strategy='afterInteractive'>
        {`
          (function(d, s, id) {
            var js, tjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "https://app.termly.io/embed-policy.min.js";
            tjs.parentNode.insertBefore(js, tjs);
          }(document, 'script', 'termly-jssdk'));
        `}
      </Script>
    </>
  )
}

PrivacyPolicy.getLayout = page => {
  return <MainLayout>{page}</MainLayout>
}

export default PrivacyPolicy
